import { normalizeLanguageCode } from 'utils/apiLanguage';

export const DEFAULT_LOCALE = 'es';

export const LOCALE_PATH_PREFIXES = ['en', 'fr', 'ca', 'eu', 'gl'];

export const isLocalePrefix = (segment) => {
  if (!segment) return false;
  return LOCALE_PATH_PREFIXES.includes(normalizeLanguageCode(segment));
};

export const getLocaleFromPathname = (pathname) => {
  const segments = (pathname || '/').split('/').filter(Boolean);
  if (segments.length > 0 && isLocalePrefix(segments[0])) {
    return normalizeLanguageCode(segments[0]);
  }
  return DEFAULT_LOCALE;
};

export const stripLocaleFromPathname = (pathname) => {
  const segments = (pathname || '/').split('/').filter(Boolean);
  if (segments.length > 0 && isLocalePrefix(segments[0])) {
    const rest = segments.slice(1);
    return rest.length ? `/${rest.join('/')}` : '/';
  }
  return pathname || '/';
};

export const resolveContentLanguage = (pathname) => getLocaleFromPathname(pathname);

export const localizePathname = (pathname, pathnameForLocale = pathname) =>
  buildLocalizedPathname(pathname, resolveContentLanguage(pathnameForLocale));

export const buildLocalizedPathname = (pathname, locale, search = '', hash = '') => {
  const pathWithoutLocale = stripLocaleFromPathname(pathname);
  const normalizedLocale = normalizeLanguageCode(locale) || DEFAULT_LOCALE;

  let path;
  if (normalizedLocale === DEFAULT_LOCALE) {
    path = pathWithoutLocale;
  } else if (pathWithoutLocale === '/') {
    path = `/${normalizedLocale}`;
  } else {
    path = `/${normalizedLocale}${pathWithoutLocale}`;
  }

  return `${path}${search}${hash}`;
};

export const getIntranetPathWithoutLocale = (pathname) => {
  const stripped = stripLocaleFromPathname(pathname || '/');
  if (stripped === '/intranet' || stripped.startsWith('/intranet/')) {
    return stripped;
  }
  return null;
};

export const isIntranetPath = (pathname) => getIntranetPathWithoutLocale(pathname) !== null;

export const isIntranetHomePath = (pathname) => {
  const intranetPath = getIntranetPathWithoutLocale(pathname);
  return intranetPath === '/intranet' || intranetPath === '/intranet/';
};

export const buildIntranetPathname = (suffix = '', locale, search = '', hash = '') => {
  const clean = suffix.replace(/^\//, '');
  const path = clean ? `/intranet/${clean}` : '/intranet';
  return buildLocalizedPathname(path, locale, search, hash);
};
